<template>
	<user-intro :userId="userId" :user="user"></user-intro>
</template>
<script>
	import { ref, inject } from "vue";
	import userIntro from "@/components/webComponents/widget/userIntro/userIntro.vue";

	export default {
		components: {
			userIntro
		},
		props: {
			userId: {
				type: [String, Number],
				default: undefined
			},
			user: {
				type: Object,
				default: () => {
					return undefined;
				}
			}
		},
		setup(props, context) {
			return {};
		}
	};
</script>